module.exports = __webpack_public_path__ + "img/obras1.2fdbd84e.svg";